import React, { useEffect } from 'react';
import { FormGroup, Label, Input, } from 'reactstrap';
import { omit, isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import { prefectures, } from '../../shared/config';
import { fields } from '../../shared/models/sender';
import { getAddressByPostalCode, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import Page from '../hocs/Page';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import SettingsTabs from '../SettingsTabs';

const { entries } = Object;

export default Page(function SettingsSenders (props) {
  const { tenant, user, } = props;
  const sendersRef = tenant.ref.collection('senders');
  const senders = useCollectionSubscription(sendersRef.orderBy('createdAt'), [tenant.id]);
  const filteredSenders = user.dev ? senders : senders.filter(_ => !_.forHanroplus);
  const onFormStateChanged = (prevStatedFields, statedFields) => {
    if(!prevStatedFields) return;
    if(prevStatedFields.postalCode.value === statedFields.postalCode.value) return;
    if(!statedFields.postalCode.isValid) return;

    (async () => {
      const [data] = await getAddressByPostalCode(statedFields.postalCode.value);
      data && statedFields.setValues(omit(data, 'address1'));
    })();
  };

  return (
    <div className="settings-senders container-fluid">
      <div className="p-4 bg-white my-4">
        <SettingsTabs activeTab="senders" />
        <div className="alert alert-info">
          伝票の配送元情報へ印字する情報になります。
          <br />
          お客様のショップ名または会社名とお客様ご自身のご住所・お電話番号の入力をお願い致します。
          <br />
          識別名は伝票へ印字されません。
        </div>
        <div className="d-flex justify-content-start mb-3">
          <AddButton itemRef={sendersRef.doc()} FormModal={ModelFormModal} formProps={{ title: '配送元 追加', fields, onStateChanged: onFormStateChanged, }} />
        </div>
        <div className="mt-3 overflow-auto">
          {
            filteredSenders.length > 0 ? (
              <table className="table sticky-table table-sm table-bordered">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 200 }}>識別名</th>
                    <th style={{ minWidth: 200 }}>郵便番号</th>
                    <th style={{ minWidth: 120 }}>都道府県</th>
                    <th style={{ minWidth: 150 }}>市区郡町村</th>
                    <th style={{ minWidth: 150 }}>町・番地</th>
                    <th style={{ minWidth: 150 }}>マンション・ビル名</th>
                    <th style={{ minWidth: 200 }}>ショップ名（事業者名）</th>
                    <th style={{ minWidth: 200 }}>電話番号</th>
                    <th style={{ minWidth: 100 }}>デフォルト</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    filteredSenders.map((sender) => {
                      const { id, ref, code, postalCode, prefecture, city, address1, address2, name, phone, isDefault = false, } = sender;
                      const onCheckDefault = async ({ target: { checked }}) => {
                        const suffix = ({ true: 'に', false: 'を解除' })[checked];
                        if(!window.confirm(`本当にデフォルト${suffix}しますか？`)) return;

                        if(checked) {
                          await Promise.all(filteredSenders.filter(_ => _.isDefault).map(_ => _.ref.update({ isDefault: false })));
                        }
                        await sender.ref.update({ isDefault: checked });
                        toast.success(`デフォルト${suffix}しました`);
                      };

                      return (
                        <tr key={id}>
                          <td>
                            {code}
                          </td>
                          <td>
                            {postalCode}
                          </td>
                          <td>
                            {prefectures[prefecture]}
                          </td>
                          <td>
                            {city}
                          </td>
                          <td>
                            {address1}
                          </td>
                          <td>
                            {address2}
                          </td>
                          <td>
                            {name}
                          </td>
                          <td>
                            {phone}
                          </td>
                          <td>
                            <FormGroup check>
                              <Label check className="mb-2">
                                <Input type="checkbox" className="mt-0" checked={isDefault} onChange={onCheckDefault} />
                              </Label>
                            </FormGroup>
                          </td>
                          <td className="text-right text-nowrap">
                            <EditButton className="ml-2" itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '配送元 編集', fields, onStateChanged: onFormStateChanged, }} />
                            <DeleteButton item={sender} itemRef={ref} className="ml-2" />
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                配送元は未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});
